import * as React from 'react';
const SvgAiAssistant = (props) => (
  <svg
    width={60}
    height={59}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      opacity={0.4}
      cx={29.6113}
      cy={36}
      r={22.5}
      fill="url(#paint0_linear_3980_21690)"
    />
    <circle
      opacity={0.6}
      cx={28.1113}
      cy={22.5}
      r={22.5}
      fill="url(#paint1_linear_3980_21690)"
    />
    <circle
      cx={35.6113}
      cy={22.5}
      r={18.75}
      fill="url(#paint2_linear_3980_21690)"
    />
    <circle
      cx={19.1113}
      cy={19.5}
      r={18.75}
      fill="url(#paint3_linear_3980_21690)"
    />
    <circle
      cx={24.3613}
      cy={22.5}
      r={18.75}
      fill="url(#paint4_linear_3980_21690)"
    />
    <circle
      cx={19.1113}
      cy={32.25}
      r={18.75}
      fill="url(#paint5_linear_3980_21690)"
    />
    <circle
      cx={34.1113}
      cy={32.25}
      r={18.75}
      fill="url(#paint6_linear_3980_21690)"
    />
    <circle
      cx={40.8613}
      cy={34.5}
      r={18.75}
      fill="url(#paint7_linear_3980_21690)"
    />
    <circle
      cx={28.1113}
      cy={28.5}
      r={18.75}
      fill="url(#paint8_radial_3980_21690)"
    />
    <g filter="url(#filter0_f_3980_21690)">
      <circle cx={28.1113} cy={28.5} r={12.75} fill="white" />
    </g>
    <defs>
      <filter
        id="filter0_f_3980_21690"
        x={4.86133}
        y={5.25}
        width={46.5}
        height={46.5}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation={5.25}
          result="effect1_foregroundBlur_3980_21690"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3980_21690"
        x1={17.4613}
        y1={12.15}
        x2={41.7613}
        y2={59.85}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A6F8E4" stopOpacity={0.35} />
        <stop offset={0.713542} stopColor="#CA98FB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3980_21690"
        x1={15.9613}
        y1={-1.35}
        x2={40.2613}
        y2={46.35}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A6C7F8" stopOpacity={0.35} />
        <stop offset={0.713542} stopColor="#9899FB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3980_21690"
        x1={25.4863}
        y1={2.625}
        x2={45.7363}
        y2={42.375}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity={0.35} />
        <stop offset={0.713542} stopColor="#98FBA2" stopOpacity={0.45} />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3980_21690"
        x1={8.98633}
        y1={-0.375001}
        x2={29.2363}
        y2={39.375}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity={0.35} />
        <stop offset={0.713542} stopColor="#9899FB" stopOpacity={0.32} />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3980_21690"
        x1={14.2363}
        y1={2.625}
        x2={34.4863}
        y2={42.375}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity={0.35} />
        <stop offset={0.713542} stopColor="#9899FB" stopOpacity={0.32} />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3980_21690"
        x1={8.98633}
        y1={12.375}
        x2={29.2363}
        y2={52.125}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity={0.35} />
        <stop offset={0.713542} stopColor="#7BB8FF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_3980_21690"
        x1={23.9863}
        y1={12.375}
        x2={44.2363}
        y2={52.125}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity={0.35} />
        <stop offset={0.713542} stopColor="#9899FB" stopOpacity={0.32} />
      </linearGradient>
      <linearGradient
        id="paint7_linear_3980_21690"
        x1={30.7363}
        y1={14.625}
        x2={50.9863}
        y2={54.375}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity={0.35} />
        <stop offset={0.864583} stopColor="#9899FB" stopOpacity={0.46} />
      </linearGradient>
      <radialGradient
        id="paint8_radial_3980_21690"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(28.1113 28.5) rotate(63.0042) scale(22.3054)"
      >
        <stop stopColor="white" />
        <stop offset={0.255208} stopColor="#FAFAFF" />
        <stop offset={0.505208} stopColor="#DCDCFD" />
        <stop offset={0.760417} stopColor="#DCE9F6" />
        <stop offset={0.958333} stopColor="#DCFDF1" />
      </radialGradient>
    </defs>
  </svg>
);
export default SvgAiAssistant;
